import { HTTP } from '@/tools/httpClient.js';


export default class ApiClient {

    async getArtistsCountAsync() {

        let response = await HTTP.get('/backoffice/artists/count');
        
        return response.data;
    }


    async getArtistsAsync(keywords, orderByField, orderBy, offset, limit) {

        let response = await HTTP.get('/backoffice/artists/?keywords=' + keywords + '&orderByField=' + orderByField + '&orderBy=' + orderBy + '&offset=' + offset + '&limit=' + limit );
        
        return response.data;
    }


    async getArtistAsync(id) {

        let response = await HTTP.get('/backoffice/artists/' + id);
        
        return response.data;
    }


    async refreshArtistAsync(musicBrainzID) {

        let response = await HTTP.get('/v2/artists/refresh/' + musicBrainzID);
        
        return response.data;
    }


    async refreshAlbumAsync(musicBrainzID) {

        let response = await HTTP.get('/v2/albums/refresh/' + musicBrainzID);
        
        return response.data;
    }


    async getAlbumsCountAsync() {

        let response = await HTTP.get('/backoffice/albums/count');
        
        return response.data;
    }


    async getAlbumsAsync(keywords, orderByField, orderBy, offset, limit) {

        let response = await HTTP.get('/backoffice/albums/?keywords=' + keywords + '&orderByField=' + orderByField + '&orderBy=' + orderBy + '&offset=' + offset + "&limit=" + limit );
        
        return response.data;
    }


    async getAlbumAsync(id) {

        let response = await HTTP.get('/backoffice/albums/' + id);
        
        return response.data;
    }


    async getLogsAsync(offset, limit) {

        let response = await HTTP.get('/backoffice/logs/?offset=' + offset + "&limit=" + limit );
        
        return response.data;
    }


    async getAllLogsAsync() {

        let response = await HTTP.get('/backoffice/logs/' );
        
        return response.data;
    }


    async getStatusAsync() {

        let response = await HTTP.get('/v2/status/' );
        
        return response.data;
    }


    async postPictureAsync(id, category, file, index = -1) {
        
        let formData = new FormData();
        formData.append('file', file);
        
        let url = '/backoffice/artists/picture/' + id + '/' + category + (index> -1 ? '/?index=' + index : '');
        await HTTP.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data'}});        
    }


    async postCoverAsync(id, file) {
        
        let formData = new FormData();
        formData.append('file', file);
        
        let url = '/backoffice/albums/picture/' + id;
        await HTTP.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data'}});    
    }


    async getLyricsCountAsync() {

        let response = await HTTP.get('/backoffice/lyrics/count');
        
        return response.data;
    }


    async getLyricsAsync(keywords, orderByField, orderBy, offset, limit) {

        let response = await HTTP.get('/backoffice/lyrics/?keywords=' + keywords + '&orderByField=' + orderByField + '&orderBy=' + orderBy + '&offset=' + offset + '&limit=' + limit );
        
        return response.data;
    }


    async getLyricAsync(id) {

        let response = await HTTP.get('/backoffice/lyrics/' + id);
        
        return response.data;
    }


    async postLyricsAsync(id, formData) {
        
        let url = '/backoffice/lyrics/' + id;
        let response = await HTTP.post(url, formData)
        
        return response.data;            
    }
}